import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "column-wide-half-add" }, [
      _createElementVNode("path", {
        id: "vector",
        d: "M8.33366 13H1.66699V8M1.66699 8V3H14.3337V8H1.66699ZM13.0003 11V13M13.0003 13V15M13.0003 13H11.0003M13.0003 13H15.0003",
        stroke: "#7F7F83",
        "stroke-linecap": "square"
      })
    ], -1)
  ])))
}
export default { render: render }